import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { TYPES } from '../../reducer'; // Import TYPES to map keys dynamically if possible

export default function useSubscribeResources(subscribeResources) {
  const dispatch = useDispatch();

  console.log('useSubscribeResources called with New:', subscribeResources);

  useEffect(
    function () {
      for (let k in subscribeResources) {
        console.log('Processing key New:', k);
        const subscribeMap = {};
        for (let r of subscribeResources[k]) {
          subscribeMap[r.id] = r;
        }

        if (k === 'availability') {
          // console.log(subscribeResources[k]);
          // console.log(k, subscribeMap);
        }

        // IMPORTANT: 
        // Since 'k' is a string like 'inspectors', 'availability', etc.,
        // you need to ensure your Reducer handles these strings OR map them to Types.
        // The reducer I wrote for you earlier uses explicit string matches in switch case
        // so passing 'inspectors' as type will work IF your reducer looks like:
        // case 'inspectors': ...
        // OR
        // case TYPES.INSPECTORS: ... (where TYPES.INSPECTORS === 'INSPECTORS')
        
        // Recommendation: Convert key to upper case for consistency with Redux types
        // dispatch({ type: k.toUpperCase(), payload: subscribeMap });
        
        // For now, based on your previous code which sent raw strings:
        dispatch({ type: k.toUpperCase(), payload: subscribeMap });
      }
    },
    [subscribeResources, dispatch]
  );
}